// Module
var code = `<div class="test-version-warning" ng-if="isTestVersion">This is a development build of the Pharmaxo Patient Manager. Do not enter real patient data</div>`;
// Exports
export default code;